import {useCodeViewAddBanner, useCodeViewBanners} from '@github-ui/code-view-shared/contexts/CodeViewBannersContext'
import {useCallback} from 'react'

export function useErrorMessage() {
  const addCodeViewBanner = useCodeViewAddBanner()
  const currentErrorBanners = useCodeViewBanners()

  const showBannerOnce = useCallback(
    (message: string) => {
      if (!currentErrorBanners.some(banner => banner.message === message)) {
        addCodeViewBanner({
          variant: 'danger',
          message,
        })
      }
    },
    [currentErrorBanners, addCodeViewBanner],
  )

  return showBannerOnce
}
